{
  "name": "@ns/company-turnover-dispute-review",
  "version": "1.0.0",
  "description": "A user disputed the turnover figure they were shown. Check the Companies House filing it was extracted from and record what you found.",
  "inputs": {
    "disputedCompanyId": {
      "type": "string"
    }
  },
  "outcomes": {
    "confirmed": {
      "inputs": {
        "reviewNotes": {
          "type": "string"
        }
      }
    },
    "corrected": {
      "inputs": {
        "correctedAmount": {
          "type": "number"
        },
        "correctedYear": {
          "type": "string"
        },
        "correctedTransactionId": {
          "type": "string"
        },
        "correctedFiledOn": {
          "type": "string"
        },
        "reviewNotes": {
          "type": "string"
        }
      }
    },
    "unknown": {
      "inputs": {
        "reviewNotes": {
          "type": "string"
        }
      }
    }
  }
}
